export const LABEL_MANAGEMENT_MODAL_TYPE = {
	ADD: 'add',
	REMOVE: 'remove',
	UPDATE: 'update'
} as const;

export const APP_TYPE = {
	WSDK: 'wsdk',
	WFA: 'wfa',
	MFA: 'mfa',
	MSDK: 'msdk'
} as const;

export type AppType = (typeof APP_TYPE)[keyof typeof APP_TYPE];

export const isMobileAppType = (appType?: AppType): boolean =>
	appType === APP_TYPE.MFA || appType === APP_TYPE.MSDK;
